// Поиск по названию над списком. Введённое уезжает в адрес (?q=…) — правило 4: та же
// выборка даёт ту же ссылку.
//
// Задержка перед записью в адрес нужна не ради сервера, а ради человека: буква за буквой
// адрес менялся бы девять раз на слове «Шлюмберже», и кнопка «назад» в браузере стала бы
// непроходимой. Enter применяет сразу, не дожидаясь задержки.

import { useEffect, useRef, useState } from 'react';

import { RiSearchLine } from '@remixicon/react';

import * as Input from '@/shared/ui/input';

/** Пауза после последней буквы. Меньше — адрес дёргается, больше — ощущается залипанием. */
const DEBOUNCE_MS = 250;

export interface SearchFilterProps {
  /** Подпись поля для чтения с экрана: «Поиск объекта по названию». */
  label: string;
  placeholder: string;
  /** Что сейчас в адресе. Источник правды — адрес, а не поле ввода. */
  value: string;
  onApply: (value: string) => void;
}

export function SearchFilter({ label, placeholder, value, onApply }: SearchFilterProps) {
  const [draft, setDraft] = useState(value);
  const onApplyRef = useRef(onApply);

  useEffect(() => {
    onApplyRef.current = onApply;
  });

  // Адрес поменялся снаружи (открыли ссылку, нажали «назад») — поле догоняет адрес.
  useEffect(() => {
    setDraft(value);
  }, [value]);

  useEffect(() => {
    if (draft === value) {
      return;
    }
    const timer = window.setTimeout(() => onApplyRef.current(draft), DEBOUNCE_MS);
    return () => window.clearTimeout(timer);
  }, [draft, value]);

  return (
    <Input.Root size='small'>
      <Input.Wrapper>
        <Input.Icon as={RiSearchLine} />
        <Input.Input
          type='search'
          aria-label={label}
          placeholder={placeholder}
          value={draft}
          onChange={(event) => setDraft(event.target.value)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              onApplyRef.current(draft);
            }
          }}
        />
      </Input.Wrapper>
    </Input.Root>
  );
}
